
<div class="card floating shadow-lg">
    <div class="card-body">

        <h3 class="card-title main-title">Future Bookings</h3>

        <table #table mat-table [dataSource]="dsAppointments" matSort multiTemplateDataRows
    class="table-striped bg-white shadow-sm container-fluid expanded-table-container">

    <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
        <td mat-cell *matCellDef="let element" class="cursor">
            {{element.startTime | date: 'MMM d, y'}}
        </td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td mat-cell *matCellDef="let element" class="cursor">
            {{element.status}}
        </td>
    </ng-container>

    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> </th>
        <td mat-cell *matCellDef="let element" class="cursor text-right">
            <!-- <button mat-icon-button *ngIf="element == expandedElement"
                (click)="expandedElement = expandedElement === element ? null : element">
                <i class="fas fa-chevron-down"></i>
            </button>
            <button mat-icon-button *ngIf="element != expandedElement"
                (click)="expandedElement = expandedElement === element ? null : element">
                <i class="fas fa-chevron-up"></i>
            </button> -->
            <button mat-flat-button class="btn btn-blue" [matMenuTriggerFor]="menu" aria-label="">
                Options
            </button>            
            <mat-menu #menu="matMenu">
                <button type="button" mat-menu-item (click)="reschedule(element)"
                    *ngIf="(element.status == 'Appointment' || element.status == 'Booked' || element.status == 'Confirmed')">
                    <!-- <mat-icon>edit_calendar</mat-icon> -->
                    <span>
                        Reschedule
                    </span>
                </button>
                <button type="button" mat-menu-item (click)="confirmDialog(element)"
                    *ngIf="element.status == 'Appointment' || element.status == 'Booked'">
                    <!-- <mat-icon>check</mat-icon> -->
                    <span>
                        Confirm
                    </span>
                </button>
                <button type="button" mat-menu-item (click)="cancelDialog(element)"
                    *ngIf="(element.status == 'Appointment' || element.status == 'Booked' || element.status == 'Confirmed')">
                    <!-- <mat-icon>event_busy</mat-icon> -->
                    <span>
                        Cancel
                    </span>
                </button>
                <button type="button" mat-menu-item (click)="rebook(element)" *ngIf="element.appointmentDetails.length==1 && !element.hasNewClientTreatment">
                    <!-- <mat-icon>check</mat-icon> -->
                    <span>
                        Rebook
                    </span>
                </button>
                <button type="button" [matMenuTriggerFor]="addCalendarMenu" mat-menu-item>
                    <!-- <mat-icon>insert_invitation</mat-icon> -->
                    <span>
                        Add to Calendar
                    </span>
                </button>
                <button type="button" class="d-none" mat-menu-item (click)="viewDetails(element)">
                    <!-- <mat-icon>event</mat-icon> -->
                    <span>
                        View Details
                    </span>
                </button>
            </mat-menu>
            <mat-menu #addCalendarMenu="matMenu">
                <a mat-menu-item type="button" *ngFor="let addEvent of addEvents" class="addeventatc full-width"
                    css="false" data-styling="none" [attr.data-direct]="addEvent.dataDirect">
                    <img [src]="addEvent.icon" style="width: 24px;margin-right: 5px;">
                    <span [innerHTML]="addEvent.description"></span>
                    <span class="all_day_event" [innerHTML]="addEvent.allDay"></span>
                    <span class="date_format" [innerHTML]="addEvent.dateFormat"></span>
                    <span class="start">{{element.startTime}}</span>
                    <span class="end">{{element.endTime}}</span>
                    <span class="title">{{element.branch.name}}</span>
                    <span class="description">
                        {{element.treatments}}
                    </span>
                    <span class="location">{{element.branch.address}}</span>
                    <span class="organizer">{{element.branch.name}}</span>
                    <span class="organizer_email">{{element.branch.email}}</span>
                </a>
            </mat-menu>
        </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="appointmentsColumns.length" class="td-expandable">
            <div class="example-element-detail" [@detailExpand]="element != expandedElement ? 'expanded' : 'collapsed'">

                <table #table mat-table [dataSource]="element.appointmentDetails" matSort multiTemplateDataRows
                    class="table-striped full-width expanded-table-bg">

                    <ng-container matColumnDef="treatment">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Treatments </th>
                        <td mat-cell *matCellDef="let detail" class="cursor">
                            <table class="fluid" style="margin-bottom:0px;cursor:pointer">
                                <tr>
                                    <td style="padding-top: 10px; padding-bottom: 10px;">
                                        <!-- <button style="float:right" mat-icon-button (click)="selectItem(detail)">
                                            <mat-icon *ngIf="detail.showDetails">expand_more</mat-icon>
                                            <mat-icon *ngIf="!detail.showDetails">expand_less</mat-icon>
                                        </button> -->
                                        {{detail.description}}
                                        <small *ngIf="!detail.showDetails">
                                            <br>
                                            <b>Staff:&nbsp;</b>{{detail.staffName}}
                                            <br>
                                            <b>Time:&nbsp;</b>{{detail.startTime | date:'h:mm a'}}
                                            <span class="d-none">
                                                - {{detail.endTime
                                                    | date:'h:mm a'}}
                                            </span>
                                            <span class="d-none">
                                                <br>
                                                <b>Additional Info:&nbsp;</b>{{detail.notes}}
                                            </span>
                                            <br>
                                            <b>Instructions:&nbsp;</b>{{detail.treatment.description}}
                                        </small>
                                    </td>
                                </tr>
                            </table>


                        </td>
                    </ng-container>

                    <ng-container matColumnDef="time">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Time </th>
                        <td mat-cell *matCellDef="let detail" class="cursor">
                            {{detail.startTime | date: 'hh:mm:a'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> </th>
                        <td mat-cell *matCellDef="let detail" class="cursor text-right">
                            <button mat-icon-button (click)="selectItem(detail)">
                                <mat-icon>navigate_next</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['treatment']"></tr>
                    <tr mat-row *matRowDef="let detail; columns: ['treatment'];">
                    </tr>

                </table>

            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="appointmentsColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: appointmentsColumns;" class="example-element-row"
        [class.example-expanded-row]="expandedElement === element">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

    <ng-container matColumnDef="loading">
        <td mat-footer-cell *matFooterCellDef colspan="4">
            <i class="fas fa-circle-notch fa-spin"></i>&nbsp;Loading data...
        </td>
    </ng-container>

    <ng-container matColumnDef="noData">
        <td mat-footer-cell *matFooterCellDef colspan="4">
            No future bookings.
        </td>
    </ng-container>

    <ng-container matColumnDef="totaRecords">
        <td mat-footer-cell *matFooterCellDef colspan="4">
            <mat-paginator [pageSize]="10" showFirstLastButtons></mat-paginator>
        </td>
    </ng-container>

    <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'d-none':dsAppointments != null}">
    </tr>

    <tr mat-footer-row *matFooterRowDef="['noData']"
        [ngClass]="{'d-none':!(dsAppointments != null && dsAppointments.data.length == 0)}">
    </tr>

    <tr mat-footer-row *matFooterRowDef="['totaRecords']"
        [ngClass]="{'d-none':!(dsAppointments != null && dsAppointments.data.length > 10)}">
    </tr>

</table>


    </div>
</div>
<br>